
document.addEventListener('DOMContentLoaded', function () {
    var title = document.title;
    var el = document.querySelector('.unfocused-message');
    if (!el) return;

    // Prefer dataset where available, fall back to attributes
    var blurMessage = el.getAttribute('data-unfocused-message') || el.dataset.unfocusedMessage || '';
    var intervalSeconds = parseInt(el.getAttribute('data-unfocused-interval') || el.dataset.unfocusedInterval, 10);
    var timeoutSeconds = parseInt(el.getAttribute('data-unfocused-timeout') || el.dataset.unfocusedTimeout, 10);

    if (isNaN(intervalSeconds)) intervalSeconds = 0;
    if (isNaN(timeoutSeconds)) timeoutSeconds = 0;

    var intervalMs = intervalSeconds * 1000;
    var timeoutMs = timeoutSeconds * 1000;

    var intervalTimer = null;
    var timeoutTimer = null;

    window.addEventListener('blur', function () {
        if (!intervalMs) return;
        if (intervalTimer) clearInterval(intervalTimer);

        intervalTimer = setInterval(function () {
            if (timeoutTimer) clearTimeout(timeoutTimer);
            document.title = blurMessage;
            timeoutTimer = setTimeout(function () {
                document.title = title;
            }, timeoutMs);
        }, intervalMs);
    });

    window.addEventListener('focus', function () {
        if (intervalTimer) {
            clearInterval(intervalTimer);
            intervalTimer = null;
        }
        if (timeoutTimer) {
            clearTimeout(timeoutTimer);
            timeoutTimer = null;
        }
        document.title = title;
    });
});


